import { allTrackers } from "app/services/track/track";

import { createManageSignalsPageTrackingService } from "./factory";

const manageSignalsPageTrackingService = createManageSignalsPageTrackingService(
    allTrackers.dispatchTrackEvent.bind(allTrackers),
);

export default manageSignalsPageTrackingService;
